export default __webpack_public_path__ + "static/media/proveedor.e64e5480.png";